import { NAV_CONTENT } from './nav-content';
import ServiceConstants from './service';

export default angular.module('searchEngineFrontend.app.shared.constants', [
])
.constant('NAV_CONTENT', NAV_CONTENT)
.constant('SERVICE', new ServiceConstants('/AUT/search-engine-frontend/secure/jas'));



// WEBPACK FOOTER //
// ./src/app/shared/constants/index.js